
const PrimiumMemberIcon = ({
  size = 16,
  fillColor = "#E7AD1B",   // Circle background
  strokeColor = "white",    // Circle border
  pathColor = "white",      // Inner badge
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        fill={fillColor}
      />
      <rect
        x="0.5"
        y="0.5"
        width="15"
        height="15"
        rx="7.5"
        stroke={strokeColor}
      />
      <path
        d="M10.925 11.375C11.0375 11.375 11.15 11.5156 11.15 11.6562V12.2188C11.15 12.377 11.0375 12.5 10.925 12.5H5.075C4.94844 12.5 4.85 12.377 4.85 12.2188V11.6562C4.85 11.5156 4.94844 11.375 5.075 11.375H10.925ZM11.825 5.75C12.1906 5.75 12.5 6.13672 12.5 6.59375C12.5 7.06836 12.1906 7.4375 11.825 7.4375C11.7828 7.4375 11.7406 7.4375 11.7125 7.4375L10.7 10.8125H5.3L4.27344 7.4375C4.24531 7.4375 4.20312 7.4375 4.175 7.4375C3.79531 7.4375 3.5 7.06836 3.5 6.59375C3.5 6.13672 3.79531 5.75 4.175 5.75C4.54063 5.75 4.85 6.13672 4.85 6.59375C4.85 6.73438 4.82188 6.83984 4.77969 6.94531L5.80625 7.71875C6.01719 7.87695 6.29844 7.78906 6.425 7.50781L7.56406 4.99414C7.42344 4.85352 7.325 4.60742 7.325 4.34375C7.325 3.88672 7.62031 3.5 8 3.5C8.36563 3.5 8.675 3.88672 8.675 4.34375C8.675 4.60742 8.57656 4.85352 8.42188 4.99414L9.56094 7.50781C9.6875 7.78906 9.96875 7.87695 10.1938 7.71875L11.2063 6.94531C11.1641 6.83984 11.15 6.73438 11.15 6.59375C11.15 6.13672 11.4453 5.75 11.825 5.75Z"
        fill={pathColor}
      />
    </svg>
  );
};

export default PrimiumMemberIcon;
